import React from 'react';
import styles from './index.module.scss'

class SecondaryButton extends React.Component {

  render() {
    return (
      <button className={`${styles.cupra} ${this.props.styletyc ? styles.tyc : ''}`} onClick={this.props.onButtonClickListener}>{this.props.title}</button>
    )
  }
}

export default SecondaryButton
